import { useMutation, useQueryClient } from 'react-query'

import { DeduplicationService } from '../services'

export const useCancelDeduplicationRun = (runId: string) => {
  const queryClient = useQueryClient()

  return useMutation(() => DeduplicationService.cancelRun(runId), {
    onSuccess: () => {
      queryClient.invalidateQueries(['deduplication-run', runId])
      queryClient.invalidateQueries(['deduplication-runs'])
      queryClient.invalidateQueries(['deduplication-run-events-infinite', runId])
    },
  })
}
